import React, { useCallback, useEffect, useMemo, useState } from "react";

import Header from "../../master/SideBar";

import Nav from "../../master/NavBar";

import MasterV2 from "../MasterV2";

import { courseList } from "../../../api/Courses";

import { batchList } from "../../../api/Batch";

import { StaffList } from "../../../api/Staff";

import { api } from "../../../api/api";

// Adjust only if your Laravel routes differ.

const LIST = "/attendance/calling-panel";

const HISTORY = "/attendance/calling-history";

const SAVE = "/followup/add";

const MODES = [
  [
    "followups",
    "Follow-ups",
    "ri-phone-line",
    "Scheduled callbacks and call records",
  ],

  [
    "today_absent",
    "Today's Absent",
    "ri-calendar-close-line",
    "Students marked absent on selected day",
  ],

  [
    "long_absent",
    "Long Absent",
    "ri-calendar-2-line",
    "Last N marked attendance records absent",
  ],

  [
    "low_attendance",
    "Low Attendance",
    "ri-bar-chart-line",
    "Attendance below chosen percentage",
  ],

  [
    "never_called",
    "Never Called",
    "ri-phone-find-line",
    "No attendance calling history",
  ],

  [
    "all_students",
    "All Students",
    "ri-group-line",
    "All active enrolled students",
  ],
];

const QUEUES = [
  ["all", "All statuses"],
  ["overdue", "Overdue"],
  ["today", "Due today"],

  ["upcoming", "Upcoming"],
  ["never", "Never called"],
  ["unscheduled", "No next date"],
];

const RESPONSES = [
  "Parent confirmed attendance",
  "No answer",
  "Phone switched off",

  "Call back requested",
  "Medical leave",
  "Out of station",
  "Parent meeting scheduled",

  "Student returning tomorrow",
  "Wrong number",
];

const dateLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const formatDate = (value) => {
  if (!value) return "—";
  const v = String(value).slice(0, 10).split("-");
  return v.length === 3 ? `${v[2]}-${v[1]}-${v[0]}` : "—";
};

const list = (v) =>
  Array.isArray(v) ? v : Array.isArray(v?.data) ? v.data : [];

const unwrap = (v) => v?.data ?? v;

const phone = (v) => String(v || "").replace(/[^\d+]/g, "");

const wa = (v) => {
  let s = String(v || "").replace(/\D/g, "");
  if (s.length === 10) s = "91" + s;
  return s ? `https\://wa.me/${s}` : "";
};

const buildQuery = (o) => {
  const p = new URLSearchParams();
  Object.entries(o).forEach(([k, v]) => {
    if (v !== "" && v != null) p.set(k, String(v));
  });
  return p.toString();
};

const defaults = {
  mode: "followups",
  queue: "all",
  session_id: "",
  course_id: "",
  batch_id: "",

  staff_id: "",
  counselor_id: "",
  search: "",
  from_date: "",
  to_date: "",

  attendance_date: dateLocal(),
  percentage: "75",
  absent_days: "3",
  min_marked_days: "2",

  sort_by: "next_followup_date",
  sort_order: "asc",
  per_page: "25",
  page: 1,
};

function Select({ label, value, options, onChange }) {
  return (
    <label className="ac-field">
      <span>{label}</span>
      <select
        className="form-select form-select-sm"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map(([id, title]) => (
          <option value={id} key={id}>
            {title}
          </option>
        ))}
      </select>
    </label>
  );
}

function statusOf(s) {
  if (!s.followup_id) return ["Never called", "never"];

  if (!s.next_followup_date) return ["No next date", "unscheduled"];

  const next = String(s.next_followup_date).slice(0, 10);

  if (next < dateLocal()) return ["Overdue", "overdue"];

  if (next === dateLocal()) return ["Due today", "today"];

  return ["Upcoming", "upcoming"];
}

export default function StudentAttendanceFollowups() {
  const [filters, setFilters] = useState(defaults);

  const [sessions, setSessions] = useState([]);

  const [courses, setCourses] = useState([]);

  const [batches, setBatches] = useState([]);

  const [staff, setStaff] = useState([]);

  const [data, setData] = useState([]);

  const [meta, setMeta] = useState({ total: 0, current_page: 1, last_page: 1 });

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const [selected, setSelected] = useState(null);

  const [history, setHistory] = useState([]);

  const [historyLoading, setHistoryLoading] = useState(false);

  const [response, setResponse] = useState("");

  const [nextFollowup, setNextFollowup] = useState("");

  const [saving, setSaving] = useState(false);

  const [toast, setToast] = useState("");

  const [showAdvanced, setShowAdvanced] = useState(false);

  const [searchInput, setSearchInput] = useState("");

  const update = (k, v) =>
    setFilters((f) => ({
      ...f,
      [k]: v,
      page: 1,

      ...(k === "course_id" || k === "session_id" ? { batch_id: "" } : {}),
    }));

  const changeMode = (m) =>
    setFilters((f) => ({
      ...f,
      mode: m,
      queue: "all",
      page: 1,

      sort_by:
        m === "low_attendance"
          ? "attendance_percentage"
          : m === "long_absent"
            ? "absent_days"
            : "next_followup_date",

      sort_order: m === "long_absent" ? "desc" : "asc",
    }));

  useEffect(() => {
    try {
      const s = JSON.parse(localStorage.getItem("sessions") || "[]");

      if (Array.isArray(s)) {
        setSessions(s);

        const active = s.find((x) => String(x.status) === "1");

        if (active)
          setFilters((f) => ({ ...f, session_id: String(active.id) }));
      }
    } catch {}

    (async () => {
      try {
        const [a, b] = await Promise.all([
          courseList(),
          StaffList("limit=all&status=1"),
        ]);

        setCourses(list(a?.data?.data?.data || a?.data?.data || a?.data));

        setStaff(list(b?.data?.data?.data || b?.data?.data || b?.data));
      } catch (e) {
        console.error("Filter loading:", e);
      }
    })();
  }, []);

  useEffect(() => {
    let live = true;

    (async () => {
      try {
        const result = await batchList(
          buildQuery({
            session_id: filters.session_id,
            course_id: filters.course_id,
          }),
        );

        if (live)
          setBatches(
            list(
              result?.data?.data?.data || result?.data?.data || result?.data,
            ),
          );
      } catch {
        if (live) setBatches([]);
      }
    })();

    return () => {
      live = false;
    };
  }, [filters.session_id, filters.course_id]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const r = unwrap(await api.get(`${LIST}?${buildQuery(filters)}`));

      if (r.status === false)
        throw Error(
          Array.isArray(r.message) ? r.message.join(", ") : r.message,
        );

      const d = r.data || {};

      setData(list(d.students));
      setMeta(d);
    } catch (e) {
      setError(
        e?.response?.data?.message?.toString() ||
          e.message ||
          "Unable to load data",
      );
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const openStudent = async (s) => {
    setSelected(s);
    setHistory([]);
    setResponse("");
    setNextFollowup("");
    setHistoryLoading(true);

    try {
      const r = unwrap(await api.get(`${HISTORY}?student_id=${s.id}`));

      if (r.status === false) throw Error(r.message);

      setHistory(list(r.data));
    } catch (e) {
      setToast(
        "History could not be loaded: " +
          (e?.response?.data?.message || e.message),
      );
    } finally {
      setHistoryLoading(false);
    }
  };

  const save = async (e) => {
    e.preventDefault();

    if (!selected || !response.trim()) return;

    setSaving(true);

    try {
      const r = unwrap(
        await api.post(SAVE, {
          user_id: selected.id,
          type: "attendance",
          response: response.trim(),

          next_followup_date: nextFollowup || null,
        }),
      );

      if (r.status === false)
        throw Error(
          Array.isArray(r.message) ? r.message.join(", ") : r.message,
        );

      setToast("Follow-up saved successfully.");

      setResponse("");
      setNextFollowup("");

      const h = unwrap(await api.get(`${HISTORY}?student_id=${selected.id}`));

      setHistory(list(h.data));

      await fetchData();
    } catch (e) {
      setToast(
        "Unable to save: " +
          (e?.response?.data?.message?.toString() || e.message),
      );
    } finally {
      setSaving(false);
    }
  };

  const sortedHeader = (key, label) => (
    <button
      type="button"
      className="ac-sort"
      onClick={() =>
        setFilters((f) => ({
          ...f,
          page: 1,
          sort_by: key,
          sort_order:
            f.sort_by === key && f.sort_order === "asc" ? "desc" : "asc",
        }))
      }
    >
      {label}{" "}
      {filters.sort_by === key
        ? filters.sort_order === "asc"
          ? "↑"
          : "↓"
        : "↕"}
    </button>
  );

  const [exporting, setExporting] = useState("");

  const [printOptions, setPrintOptions] = useState(false);

  const [printScope, setPrintScope] = useState("all");

  const [printColumns, setPrintColumns] = useState({
    registration: true,
    student: true,
    father: true,
    phone: true,
    secondary: true,
    course: true,
    batch: true,
    present: true,
    absent: true,
    marked: true,
    percentage: true,
    lastAttendance: false,
    lastCall: true,
    nextCall: true,
    response: true,
    status: true,
  });

  const [printTitle, setPrintTitle] = useState(
    "Student Attendance Calling List",
  );

  const exportFields = [
    ["registration", "Registration No.", (s) => s.registration_no],

    ["student", "Student Name", (s) => s.name],

    ["father", "Father Name", (s) => s.father_name],

    ["phone", "Mobile", (s) => s.phone],

    ["secondary", "Alternate Mobile", (s) => s.secondary_mobile],

    ["course", "Course / Class", (s) => s.course_title],

    ["batch", "Batch", (s) => s.batch_title],

    ["present", "Present Days", (s) => s.present_days],

    ["absent", "Absent Days", (s) => s.absent_days],

    ["marked", "Marked Days", (s) => s.marked_days],

    ["percentage", "Attendance %", (s) => s.attendance_percentage],

    [
      "lastAttendance",
      "Last Attendance",
      (s) => formatDate(s.last_attendance_date),
    ],

    ["lastCall", "Last Call", (s) => formatDate(s.followup_date)],

    ["nextCall", "Next Follow-up", (s) => formatDate(s.next_followup_date)],

    ["response", "Last Response", (s) => s.response],

    ["status", "Calling Status", (s) => statusOf(s)[0]],
  ];

  const getExportRows = async (scope) => {
    if (scope === "page") return [...data];

    const all = [];

    const pageSize = 200;

    const count = Math.ceil(Number(meta.total || 0) / pageSize);

    if (count > 500)
      throw Error(
        "More than 100,000 records match. Please narrow filters before exporting.",
      );

    for (let page = 1; page <= Math.max(1, count); page++) {
      const query = buildQuery({ ...filters, page, per_page: pageSize });

      const response = unwrap(await api.get(`${LIST}?${query}`));

      if (response.status === false)
        throw Error(response.message || "Export request failed");

      const payload = response.data || {};

      const records = list(payload.students);

      if (!records.length) break;

      all.push(...records);

      if (records.length < pageSize) break;
    }

    return all;
  };

  const htmlEscape = (v) =>
    String(v ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const exportCSV = async (scope = "all") => {
    if (exporting) return;

    setExporting("excel");

    try {
      const rows = await getExportRows(scope);

      if (!rows.length) {
        setToast("No students available for export.");
        return;
      }

      const fields = exportFields.filter(([key]) => printColumns[key]);

      if (!fields.length) {
        setToast("Select at least one column.");
        return;
      }

      const csvCell = (value) =>
        `"${String(value ?? "")
          .replace(/^[=+@\-\t\r]/, (m) => "'" + m)
          .replace(/"/g, '""')}"`;

      const csv = [
        fields.map((x) => x[1]),
        ...rows.map((s) => fields.map((x) => x[2](s))),
      ]
        .map((row) => row.map(csvCell).join(","))
        .join("\r\n");

      const blob = new Blob(["\uFEFF", csv], {
        type: "text/csv;charset=utf-8;",
      });

      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `attendance-calling-${filters.mode}-${dateLocal()}.csv`;

      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);

      setToast(
        `Exported ${rows.length} students. Open the CSV in Excel to print or save as .xlsx.`,
      );
    } catch (e) {
      setToast(
        `Excel export failed: ${e?.response?.data?.message || e.message}`,
      );
    } finally {
      setExporting("");
    }
  };

  const printList = async (scope = "all") => {
    if (exporting) return;

    // Open immediately from the click event, before awaiting the API, to avoid popup blockers.

    const popup = window.open("", "_blank");

    if (!popup) {
      setToast("Allow pop-ups for this website to print the calling list.");
      return;
    }

    popup.document.write(
      "<!doctype html><html><head><title>Preparing print...</title></head><body style='font-family:Arial;padding:30px'>Preparing printable calling list...</body></html>",
    );

    setExporting("print");

    try {
      const rows = await getExportRows(scope);

      if (!rows.length) {
        popup.close();
        setToast("No students available for printing.");
        return;
      }

      const fields = exportFields.filter(([key]) => printColumns[key]);

      if (!fields.length) {
        popup.close();
        setToast("Select at least one column.");
        return;
      }

      const tableHead = fields
        .map((x) => `<th>${htmlEscape(x[1])}</th>`)
        .join("");

      const tableBody = rows
        .map(
          (s, i) =>
            `<tr><td>${i + 1}</td>${fields.map((x) => `<td>${htmlEscape(x[2](s))}</td>`).join("")}</tr>`,
        )
        .join("");

      const sessionName =
        sessions.find((x) => String(x.id) === String(filters.session_id))
          ?.session || "All sessions";

      const doc = `<!doctype html><html><head><meta charset="utf-8"><title>${htmlEscape(printTitle)}</title><style>

      @page{size:A4 landscape;margin:9mm}*{box-sizing:border-box}body{font-family:Arial,Helvetica,sans-serif;color:#1f2937;margin:0;font-size:10px}

      .toolbar{padding:10px 0;margin-bottom:12px;display:flex;gap:8px}.toolbar button{border:1px solid #aaa;border-radius:5px;background:#fff;padding:8px 15px;cursor:pointer}

      h1{font-size:17px;text-align:center;margin:4px 0 7px}.meta{text-align:center;font-size:10px;margin-bottom:12px;color:#555}

      table{width:100%;border-collapse:collapse;table-layout:auto}thead{display:table-header-group}tr{break-inside:avoid;page-break-inside:avoid}

      th,td{border:1px solid #777;padding:5px 4px;text-align:left;vertical-align:top;overflow-wrap:anywhere}

      th{background:#e9ecf5!important;color:#111;font-weight:700;-webkit-print-color-adjust:exact;print-color-adjust:exact}

      tbody tr:nth-child(even){background:#f8f9fc!important;-webkit-print-color-adjust:exact;print-color-adjust:exact}

      .footer{margin-top:10px;display:flex;justify-content:space-between;font-size:9px}

      @media print{.toolbar{display:none}body{font-size:9px}th,td{padding:4px 3px}}

      </style></head><body><div class="toolbar"><button onclick="window.print()">Print / Save PDF</button><button onclick="window.close()">Close</button></div>

      <h1>${htmlEscape(printTitle || "Student Attendance Calling List")}</h1>

      <div class="meta">${htmlEscape(modeTitle)} | Session: ${htmlEscape(sessionName)} | Date: ${htmlEscape(dateLocal())} | Records: ${rows.length}</div>

      <table><thead><tr><th>#</th>${tableHead}</tr></thead><tbody>${tableBody}</tbody></table>

      <div class="footer"><span>Generated: ${htmlEscape(new Date().toLocaleString("en-IN"))}</span><span>Staff calling / physical follow-up sheet</span></div>

      </body></html>`;

      popup.document.open();
      popup.document.write(doc);
      popup.document.close();
      popup.focus();

      setToast(
        `Printable list ready: ${rows.length} students. Use Print / Save PDF in the new tab.`,
      );
    } catch (e) {
      popup.close();
      setToast(`Printing failed: ${e?.response?.data?.message || e.message}`);
    } finally {
      setExporting("");
    }
  };

  const stats = useMemo(() => {
    const result = {
      overdue: 0,
      today: 0,
      upcoming: 0,
      never: 0,
      unscheduled: 0,
    };

    data.forEach((s) => {
      result[statusOf(s)[1]]++;
    });

    return result;
  }, [data]);

  const modeTitle = MODES.find((x) => x[0] === filters.mode)?.[1] || "Calling";

  return (
    <>
      <div className="layout-wrapper layout-content-navbar ac-root attendance-dashboard">
        <div className="layout-container">
          <div className="no-print">
            <Header />
          </div>
          <div className="layout-page">
            <div className="no-print">
              <Nav />
            </div>
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y ac-page">
                <div className="ac-master-v2 no-print">
                  <MasterV2 />
                </div>

                <div className="ac-top">
                  <div>
                    <small className="ac-kicker">
                      STUDENT ATTENDANCE / FOLLOW-UPS
                    </small>
                    <h4>Student Attendance Follow-ups</h4>

                    <p>
                      Manage parent calls, absence follow-ups and scheduled
                      callbacks.
                    </p>
                  </div>

                  <div className="ac-actions">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={fetchData}
                      disabled={loading}
                    >
                      <i className="ri-refresh-line me-1" />
                      Refresh
                    </button>

                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => setPrintOptions(true)}
                      disabled={loading || !!exporting}
                    >
                      <i className="ri-file-excel-2-line me-1" />
                      Print / Excel Options
                    </button>

                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => printList("page")}
                      disabled={loading || !!exporting}
                    >
                      <i className="ri-printer-line me-1" />
                      Print Current Page
                    </button>
                  </div>
                </div>

                <div className="ac-modes">
                  {MODES.map(([id, title, icon, description]) => (
                    <button
                      key={id}
                      className={`ac-mode ${filters.mode === id ? "active" : ""}`}
                      onClick={() => changeMode(id)}
                    >
                      <i className={icon} />
                      <strong>{title}</strong>
                      <small>{description}</small>
                    </button>
                  ))}
                </div>

                <section className="ac-box">
                  <div className="ac-section-head">
                    <strong>
                      <i className="ri-equalizer-line me-1" /> Calling Filters
                    </strong>

                    <div>
                      <button
                        className="btn btn-link btn-sm"
                        onClick={() => setShowAdvanced((v) => !v)}
                      >
                        {showAdvanced ? "Hide" : "More"} filters
                      </button>

                      <button
                        className="btn btn-link btn-sm"
                        onClick={() => {
                          setFilters({
                            ...defaults,
                            session_id: filters.session_id,
                          });
                          setSearchInput("");
                        }}
                      >
                        Reset
                      </button>
                    </div>
                  </div>

                  <div className="ac-filters">
                    <label className="ac-field ac-search">
                      <span>Search student / registration / mobile</span>

                      <div className="ac-search-row">
                        <input
                          className="form-control form-control-sm"
                          placeholder="Type name, father, phone..."
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                        />

                        <button
                          className="btn btn-primary btn-sm"
                          type="button"
                          onClick={() => update("search", searchInput.trim())}
                        >
                          Search
                        </button>
                      </div>
                    </label>

                    <Select
                      label="Session"
                      value={filters.session_id}
                      onChange={(v) => update("session_id", v)}
                      options={[
                        ["", "Active session"],
                        ...sessions.map((s) => [
                          s.id,
                          s.session || s.title || s.name || s.id,
                        ]),
                      ]}
                    />

                    <Select
                      label="Course"
                      value={filters.course_id}
                      onChange={(v) => update("course_id", v)}
                      options={[
                        ["", "All courses"],
                        ...courses.map((c) => [c.id, c.title || c.name]),
                      ]}
                    />

                    <Select
                      label="Batch"
                      value={filters.batch_id}
                      onChange={(v) => update("batch_id", v)}
                      options={[
                        ["", "All batches"],
                        ...batches.map((b) => [b.id, b.title || b.name]),
                      ]}
                    />

                    <Select
                      label="Follow-up Queue"
                      value={filters.queue}
                      onChange={(v) => update("queue", v)}
                      options={QUEUES}
                    />

                    {filters.mode === "today_absent" && (
                      <label className="ac-field">
                        <span>Attendance Date</span>
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={filters.attendance_date}
                          onChange={(e) =>
                            update("attendance_date", e.target.value)
                          }
                        />
                      </label>
                    )}

                    {filters.mode === "long_absent" && (
                      <label className="ac-field">
                        <span>Last N marked days absent</span>
                        <input
                          type="number"
                          min="1"
                          max="30"
                          className="form-control form-control-sm"
                          value={filters.absent_days}
                          onChange={(e) =>
                            update("absent_days", e.target.value)
                          }
                        />
                      </label>
                    )}

                    {filters.mode === "low_attendance" && (
                      <label className="ac-field">
                        <span>Attendance below (%)</span>
                        <input
                          type="number"
                          min="0"
                          max="100"
                          className="form-control form-control-sm"
                          value={filters.percentage}
                          onChange={(e) => update("percentage", e.target.value)}
                        />
                      </label>
                    )}

                    {showAdvanced && (
                      <>
                        <Select
                          label="Class Teacher"
                          value={filters.staff_id}
                          onChange={(v) => update("staff_id", v)}
                          options={[
                            ["", "All teachers"],
                            ...staff.map((s) => [s.id, s.name]),
                          ]}
                        />

                        <Select
                          label="Called By"
                          value={filters.counselor_id}
                          onChange={(v) => update("counselor_id", v)}
                          options={[
                            ["", "All staff"],
                            ...staff.map((s) => [s.id, s.name]),
                          ]}
                        />

                        <label className="ac-field">
                          <span>Attendance From</span>
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            value={filters.from_date}
                            onChange={(e) =>
                              update("from_date", e.target.value)
                            }
                          />
                        </label>

                        <label className="ac-field">
                          <span>Attendance To</span>
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            value={filters.to_date}
                            onChange={(e) => update("to_date", e.target.value)}
                          />
                        </label>

                        <label className="ac-field">
                          <span>Minimum marked days</span>
                          <input
                            type="number"
                            min="1"
                            max="365"
                            className="form-control form-control-sm"
                            value={filters.min_marked_days}
                            onChange={(e) =>
                              update("min_marked_days", e.target.value)
                            }
                          />
                        </label>
                      </>
                    )}

                    <Select
                      label="Sort by"
                      value={filters.sort_by}
                      onChange={(v) => update("sort_by", v)}
                      options={[
                        ["next_followup_date", "Next follow-up"],
                        ["followup_date", "Last called"],

                        ["attendance_percentage", "Attendance %"],
                        ["absent_days", "Absent days"],

                        ["last_attendance_date", "Last attendance"],
                        ["name", "Student name"],
                        ["created_at", "Call created"],
                      ]}
                    />

                    <Select
                      label="Order"
                      value={filters.sort_order}
                      onChange={(v) => update("sort_order", v)}
                      options={[
                        ["asc", "Ascending ↑"],
                        ["desc", "Descending ↓"],
                      ]}
                    />

                    <Select
                      label="Rows"
                      value={filters.per_page}
                      onChange={(v) => update("per_page", v)}
                      options={[
                        ["25", "25"],
                        ["50", "50"],
                        ["100", "100"],
                        ["200", "200"],
                      ]}
                    />
                  </div>
                </section>

                <div className="ac-summary">
                  <div>
                    <small>Matching students</small>
                    <strong>{meta.total || 0}</strong>
                  </div>

                  <div>
                    <small>Overdue on this page</small>
                    <strong>{stats.overdue}</strong>
                  </div>

                  <div>
                    <small>Due today on this page</small>
                    <strong>{stats.today}</strong>
                  </div>

                  <div>
                    <small>Upcoming on this page</small>
                    <strong>{stats.upcoming}</strong>
                  </div>

                  <div>
                    <small>Never called on this page</small>
                    <strong>{stats.never}</strong>
                  </div>
                </div>

                <section className="ac-box">
                  <div className="ac-section-head">
                    <div>
                      <strong>{modeTitle} Calling List</strong>
                      <small className="d-block text-muted">
                        Showing {data.length} students • {meta.total || 0}{" "}
                        matching • Page {meta.current_page || 1} of{" "}
                        {meta.last_page || 1}
                      </small>
                    </div>

                    {loading && (
                      <span className="spinner-border spinner-border-sm text-primary" />
                    )}
                  </div>

                  {error && (
                    <div className="alert alert-danger m-3">
                      {String(error)}
                    </div>
                  )}

                  <div className="table-responsive ac-desktop-table">
                    <table className="table table-hover ac-table mb-0">
                      <thead>
                        <tr>
                          <th>#</th>

                          <th>{sortedHeader("name", "Student Details")}</th>

                          <th>Parent Contact</th>

                          <th>Class & Attendance</th>

                          <th>
                            {sortedHeader(
                              "attendance_percentage",
                              "Attendance %",
                            )}
                          </th>

                          <th>Last Call / Response</th>

                          <th>
                            {sortedHeader(
                              "next_followup_date",
                              "Next Follow-up",
                            )}
                          </th>

                          <th>Status</th>

                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data.map((s, i) => {
                          const [status, kind] = statusOf(s);

                          const pct = Number(s.attendance_percentage || 0);

                          const color =
                            pct < 40
                              ? "critical"
                              : pct < 60
                                ? "danger"
                                : pct < 75
                                  ? "warning"
                                  : "good";

                          return (
                            <tr key={s.id}>
                              <td className="ac-row-number">
                                {((meta.current_page || 1) - 1) *
                                  Number(filters.per_page) +
                                  i +
                                  1}
                              </td>

                              <td>
                                <div className="ac-student-cell">
                                  <span className="ac-avatar">
                                    {String(s.name || "?")
                                      .trim()
                                      .split(/\s+/)
                                      .slice(0, 2)
                                      .map((x) => x[0])
                                      .join("")
                                      .toUpperCase()}
                                  </span>

                                  <div>
                                    <strong>{s.name || "—"}</strong>
                                    <small>
                                      Reg: {s.registration_no || "—"}
                                    </small>
                                    <small>
                                      Father: {s.father_name || "—"}
                                    </small>
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div className="ac-stack">
                                  <strong>{s.phone || "—"}</strong>
                                  {s.secondary_mobile && (
                                    <small>Alt: {s.secondary_mobile}</small>
                                  )}

                                  <div className="ac-inline-actions">
                                    {phone(s.phone) && (
                                      <a
                                        href={`tel:${phone(s.phone)}`}
                                        title="Call parent"
                                      >
                                        <i className="ri-phone-line" />
                                      </a>
                                    )}

                                    {wa(s.phone) && (
                                      <a
                                        href={wa(s.phone)}
                                        target="_blank"
                                        rel="noreferrer"
                                        title="WhatsApp"
                                      >
                                        <i className="ri-whatsapp-line" />
                                      </a>
                                    )}
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div className="ac-stack ac-class-cell">
                                  <strong>{s.course_title || "—"}</strong>
                                  <small>{s.batch_title || "—"}</small>

                                  <div className="ac-attendance-counts">
                                    <span className="present">
                                      {s.present_days} Present
                                    </span>
                                    <span className="absent">
                                      {s.absent_days} Absent
                                    </span>
                                  </div>

                                  <small>
                                    {s.marked_days} days marked · Last:{" "}
                                    {formatDate(s.last_attendance_date)}
                                  </small>
                                </div>
                              </td>

                              <td>
                                <div className="ac-progress">
                                  <div>
                                    <strong className={color}>
                                      {s.marked_days
                                        ? `${pct.toFixed(1)}%`
                                        : "—"}
                                    </strong>
                                    <small>{s.marked_days} days</small>
                                  </div>

                                  <div className="ac-progress-track">
                                    <span
                                      className={color}
                                      style={{
                                        width: `${Math.max(0, Math.min(100, pct))}%`,
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>

                              <td>
                                <div className="ac-stack ac-response-cell">
                                  <strong title={s.response || ""}>
                                    {s.response || "No response recorded"}
                                  </strong>

                                  <small>
                                    Last called: {formatDate(s.followup_date)}
                                  </small>
                                </div>
                              </td>

                              <td className="ac-date">
                                <strong>
                                  {formatDate(s.next_followup_date)}
                                </strong>
                              </td>

                              <td>
                                <span className={`ac-pill ${kind}`}>
                                  {status}
                                </span>
                              </td>

                              <td>
                                <button
                                  className="ac-followup-btn"
                                  onClick={() => openStudent(s)}
                                >
                                  <i className="ri-phone-line" /> Call / History
                                </button>
                              </td>
                            </tr>
                          );
                        })}

                        {!data.length && !loading && (
                          <tr>
                            <td
                              colSpan={9}
                              className="text-center text-muted py-5"
                            >
                              No students match the selected filters.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="ac-mobile-list">
                    {data.map((s) => {
                      const [status, kind] = statusOf(s);

                      const pct = Number(s.attendance_percentage || 0);

                      return (
                        <div className="ac-mobile-card" key={s.id}>
                          <div className="ac-mobile-head">
                            <div className="ac-student-cell">
                              <span className="ac-avatar">
                                {String(s.name || "?")
                                  .trim()
                                  .slice(0, 1)
                                  .toUpperCase()}
                              </span>

                              <div>
                                <strong>{s.name}</strong>
                                <small>
                                  {s.registration_no || "—"} ·{" "}
                                  {s.father_name || "—"}
                                </small>
                              </div>
                            </div>

                            <span className={`ac-pill ${kind}`}>{status}</span>
                          </div>

                          <div className="ac-mobile-grid">
                            <div>
                              <small>Class / Batch</small>
                              <strong>{s.course_title || "—"}</strong>
                              <span>{s.batch_title || "—"}</span>
                            </div>

                            <div>
                              <small>Attendance</small>
                              <strong>{pct.toFixed(1)}%</strong>
                              <span>
                                {s.present_days} P / {s.absent_days} A
                              </span>
                            </div>

                            <div>
                              <small>Last Call</small>
                              <strong>{formatDate(s.followup_date)}</strong>
                              <span>{s.response || "No response"}</span>
                            </div>

                            <div>
                              <small>Next Follow-up</small>
                              <strong>
                                {formatDate(s.next_followup_date)}
                              </strong>
                              <span>{s.phone || "—"}</span>
                            </div>
                          </div>

                          <div className="ac-mobile-actions">
                            <button
                              className="ac-followup-btn"
                              onClick={() => openStudent(s)}
                            >
                              <i className="ri-phone-line" /> Call / History
                            </button>

                            {phone(s.phone) && (
                              <a
                                href={`tel:${phone(s.phone)}`}
                                className="btn btn-outline-success btn-sm"
                              >
                                <i className="ri-phone-fill" /> Call
                              </a>
                            )}

                            {wa(s.phone) && (
                              <a
                                href={wa(s.phone)}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-success btn-sm"
                              >
                                <i className="ri-whatsapp-line" /> WhatsApp
                              </a>
                            )}
                          </div>
                        </div>
                      );
                    })}

                    {!data.length && !loading && (
                      <div className="ac-mobile-card text-center text-muted">
                        No students match the selected filters.
                      </div>
                    )}
                  </div>

                  <div className="ac-footer">
                    <small>
                      Records are sorted and paginated on the server.
                    </small>

                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        disabled={loading || filters.page <= 1}
                        onClick={() =>
                          setFilters((f) => ({ ...f, page: f.page - 1 }))
                        }
                      >
                        Previous
                      </button>

                      <span>
                        {meta.current_page || 1} / {meta.last_page || 1}
                      </span>

                      <button
                        className="btn btn-outline-secondary btn-sm"
                        disabled={
                          loading || filters.page >= (meta.last_page || 1)
                        }
                        onClick={() =>
                          setFilters((f) => ({ ...f, page: f.page + 1 }))
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selected && (
        <div
          className="ac-overlay"
          onMouseDown={() => !saving && setSelected(null)}
        >
          <div className="ac-modal" onMouseDown={(e) => e.stopPropagation()}>
            <div className="ac-modal-head">
              <div>
                <small>ATTENDANCE CALL RECORD</small>
                <h5>{selected.name}</h5>

                <p>
                  {selected.registration_no || "—"} •{" "}
                  {selected.batch_title || "—"} • Father:{" "}
                  {selected.father_name || "—"}
                </p>
              </div>

              <button
                type="button"
                className="btn-close"
                onClick={() => setSelected(null)}
              />
            </div>

            <div className="ac-modal-body">
              <div className="ac-callrow">
                <div>
                  <small>Parent mobile</small>
                  <strong>{selected.phone || "Not available"}</strong>
                </div>

                <div className="d-flex gap-2">
                  {phone(selected.phone) && (
                    <a
                      href={`tel:${phone(selected.phone)}`}
                      className="btn btn-success btn-sm"
                    >
                      <i className="ri-phone-fill me-1" />
                      Call
                    </a>
                  )}

                  {wa(selected.phone) && (
                    <a
                      href={wa(selected.phone)}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-outline-success btn-sm"
                    >
                      <i className="ri-whatsapp-line me-1" />
                      WhatsApp
                    </a>
                  )}
                </div>
              </div>

              <div className="ac-mini">
                <span>
                  Present <strong>{selected.present_days}</strong>
                </span>
                <span>
                  Absent <strong>{selected.absent_days}</strong>
                </span>

                <span>
                  Attendance <strong>{selected.attendance_percentage}%</strong>
                </span>
                <span>
                  Next follow-up{" "}
                  <strong>{formatDate(selected.next_followup_date)}</strong>
                </span>
              </div>

              <h6 className="fw-bold mt-3">
                Calling History ({history.length})
              </h6>

              <div className="ac-history">
                {historyLoading ? (
                  <p>Loading history...</p>
                ) : history.length ? (
                  history.map((h) => (
                    <div className="ac-history-item" key={h.id}>
                      <div>
                        <strong>{h.response}</strong>
                        <small>{formatDate(h.followup_date)}</small>
                      </div>

                      <small>
                        Next: {formatDate(h.next_followup_date)} • Called by:{" "}
                        {h.counselor?.name || "—"}
                      </small>
                    </div>
                  ))
                ) : (
                  <p className="text-muted small">
                    No attendance follow-ups yet.
                  </p>
                )}
              </div>

              <form onSubmit={save}>
                <h6 className="fw-bold mt-3">Record New Follow-up</h6>

                <div className="ac-quick">
                  {RESPONSES.map((t) => (
                    <button
                      type="button"
                      key={t}
                      className={`ac-chip ${response === t ? "active" : ""}`}
                      onClick={() => setResponse(t)}
                    >
                      {t}
                    </button>
                  ))}
                </div>

                <label className="form-label mt-3">
                  Parent response / remarks *
                </label>

                <textarea
                  className="form-control"
                  rows="3"
                  required
                  maxLength={2000}
                  value={response}
                  onChange={(e) => setResponse(e.target.value)}
                  placeholder="Record the call outcome and reason for absence..."
                />

                <label className="form-label mt-3">
                  Next follow-up date (optional)
                </label>

                <input
                  type="date"
                  className="form-control"
                  min={dateLocal()}
                  value={nextFollowup}
                  onChange={(e) => setNextFollowup(e.target.value)}
                />

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setSelected(null)}
                  >
                    Close
                  </button>

                  <button
                    type="submit"
                    disabled={saving || !response.trim()}
                    className="btn btn-primary"
                  >
                    {saving ? "Saving..." : "Save Follow-up"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {printOptions && (
        <div
          className="ac-overlay"
          onMouseDown={() => !exporting && setPrintOptions(false)}
        >
          <div
            className="ac-modal"
            style={{ maxWidth: 650 }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <div className="ac-modal-head">
              <div>
                <small>PRINT & EXCEL</small>
                <h5>Calling Sheet Options</h5>
                <p>
                  Prepare a staff calling list or export to Excel-compatible
                  CSV.
                </p>
              </div>
              <button
                type="button"
                className="btn-close"
                disabled={!!exporting}
                onClick={() => setPrintOptions(false)}
              />
            </div>

            <div className="ac-modal-body">
              <label className="form-label fw-semibold">Print heading</label>

              <input
                className="form-control mb-3"
                value={printTitle}
                onChange={(e) => setPrintTitle(e.target.value)}
                maxLength={100}
              />

              <label className="form-label fw-semibold">
                Records to include
              </label>

              <div className="d-flex flex-wrap gap-3 mb-3">
                <label>
                  <input
                    type="radio"
                    checked={printScope === "all"}
                    onChange={() => setPrintScope("all")}
                  />{" "}
                  All matching students ({meta.total || 0})
                </label>

                <label>
                  <input
                    type="radio"
                    checked={printScope === "page"}
                    onChange={() => setPrintScope("page")}
                  />{" "}
                  Current page ({data.length})
                </label>
              </div>

              <label className="form-label fw-semibold">
                Columns for print / Excel
              </label>

              <div className="ac-print-fields">
                {exportFields.map(([key, label]) => (
                  <label key={key}>
                    <input
                      type="checkbox"
                      checked={!!printColumns[key]}
                      onChange={(e) =>
                        setPrintColumns((v) => ({
                          ...v,
                          [key]: e.target.checked,
                        }))
                      }
                    />
                    {label}
                  </label>
                ))}
              </div>

              <p className="small text-muted mt-3 mb-2">
                For physical staff calling, keep Mobile, Student, Father, Class,
                Last Response and Next Follow-up selected. Print uses A4
                landscape with repeated table headers.
              </p>

              <div className="d-flex flex-wrap justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setPrintOptions(false)}
                  disabled={!!exporting}
                >
                  Close
                </button>

                <button
                  type="button"
                  className="btn btn-outline-success"
                  onClick={() => exportCSV(printScope)}
                  disabled={!!exporting}
                >
                  {exporting === "excel"
                    ? "Exporting..."
                    : "Download Excel (CSV)"}
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => printList(printScope)}
                  disabled={!!exporting}
                >
                  {exporting === "print" ? "Preparing..." : "Open Print Sheet"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {toast && (
        <div className="ac-toast" role="alert">
          {toast}
          <button className="btn-close ms-3" onClick={() => setToast("")} />
        </div>
      )}

      <style>{`

     .ac-print-fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:9px;padding:12px;border:1px solid #e3e7ed;border-radius:10px;max-height:230px;overflow:auto}

     .ac-print-fields label{display:flex;align-items:center;gap:8px;font-size:12px;margin:0}

     @media(max-width:480px){.ac-print-fields{grid-template-columns:1fr}}







      .ac-root{--ac-border:var(--bs-border-color,#e5e7eb);--ac-bg:var(--bs-body-bg,#fff);--ac-text:var(--bs-body-color,#344054)}







      .ac-top,.ac-box,.ac-mode,.ac-summary>div{border:1px solid var(--ac-border);border-radius:14px;background:var(--ac-bg)}







      .ac-top{padding:18px;display:flex;justify-content:space-between;align-items:center;gap:15px;margin-bottom:13px}







      .ac-top h4{font-weight:800;margin:3px 0}.ac-top p{margin:0;font-size:12px;color:#8992a3}







      .ac-kicker{font-size:10px;font-weight:800;letter-spacing:.08em;color:#7367f0}







      .ac-actions{display:flex;flex-wrap:wrap;gap:7px}







      .ac-modes{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:9px;margin-bottom:13px}







      .ac-mode{display:flex;flex-direction:column;text-align:left;padding:14px 11px;gap:5px;color:var(--ac-text)}







      .ac-mode i{font-size:24px;color:#7367f0}.ac-mode strong{font-size:12px}.ac-mode small{font-size:10px;color:#8992a3;line-height:1.35}







      .ac-mode.active{border-color:#7367f0;background:rgba(115,103,240,.07);box-shadow:0 0 0 1px rgba(115,103,240,.16)}







      .ac-box{margin-bottom:13px;overflow:hidden}







      .ac-section-head{padding:13px 16px;border-bottom:1px solid var(--ac-border);display:flex;justify-content:space-between;align-items:center}







      .ac-section-head strong{font-size:14px}.ac-section-head small{font-size:11px}







      .ac-filters{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:10px;padding:13px}







      .ac-field{min-width:0}.ac-field>span{display:block;font-size:10px;font-weight:700;margin-bottom:5px;color:#8992a3}







      .ac-field .form-control,.ac-field .form-select{font-size:12px;min-height:34px}







      .ac-search{grid-column:span 2}.ac-search form{display:flex;gap:5px}







      .ac-summary{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:9px;margin-bottom:13px}







      .ac-summary>div{padding:13px}.ac-summary small{display:block;color:#8992a3;font-size:11px}.ac-summary strong{font-size:21px}







      .ac-table{min-width:1460px}.ac-table th{background:rgba(115,103,240,.07);white-space:nowrap;font-size:10px;padding:12px}







      .ac-table td{font-size:11px;vertical-align:middle;padding:11px}.ac-table td strong{font-size:11px}







      .ac-sort{background:none;border:0;font:inherit;color:inherit;font-weight:700;padding:0;cursor:pointer}







      .ac-date{white-space:nowrap;font-variant-numeric:tabular-nums}.ac-remark{max-width:170px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}







      .ac-pill{display:inline-block;border-radius:50px;padding:5px 9px;font-size:10px;font-weight:700;white-space:nowrap}







      .ac-pill.overdue{background:#fee2e2;color:#b91c1c}.ac-pill.today{background:#e0f2fe;color:#0369a1}







      .ac-pill.upcoming{background:#dcfce7;color:#15803d}.ac-pill.never{background:#fef3c7;color:#92400e}







      .ac-pill.unscheduled{background:#f3f4f6;color:#6b7280}







      .ac-footer{display:flex;justify-content:space-between;align-items:center;padding:12px 16px;font-size:11px}







      .ac-overlay{position:fixed;inset:0;background:rgba(15,23,42,.65);z-index:1150;display:grid;place-items:center;padding:12px}







      .ac-modal{width:min(720px,100%);max-height:95vh;overflow:auto;border-radius:16px;background:var(--bs-body-bg,#fff);color:var(--bs-body-color,#344054);box-shadow:0 25px 70px #0005}







      .ac-modal-head{display:flex;justify-content:space-between;padding:17px 20px;border-bottom:1px solid var(--bs-border-color)}







      .ac-modal-head small{font-size:10px;color:#7367f0;font-weight:800}.ac-modal-head h5{font-weight:800;margin:4px 0}







      .ac-modal-head p{font-size:11px;color:#8992a3;margin:0}.ac-modal-body{padding:17px 20px}







      .ac-callrow{display:flex;justify-content:space-between;align-items:center;padding:13px;border-radius:10px;background:rgba(115,103,240,.08)}







      .ac-callrow small{display:block;color:#8992a3}.ac-callrow strong{font-size:17px}







      .ac-mini{display:grid;grid-template-columns:repeat(4,1fr);gap:7px;margin-top:10px}







      .ac-mini span{padding:9px;border:1px solid var(--bs-border-color);border-radius:8px;font-size:10px}







      .ac-mini strong{display:block;font-size:12px}.ac-history{max-height:200px;overflow:auto}







      .ac-history-item{border:1px solid var(--bs-border-color);padding:10px;margin-bottom:7px;border-radius:9px}







      .ac-history-item>div{display:flex;justify-content:space-between;gap:12px}







      .ac-history-item strong{font-size:12px}.ac-history-item small{font-size:10px;color:#8992a3}







      .ac-quick{display:flex;flex-wrap:wrap;gap:6px}







      .ac-chip{border:1px solid var(--bs-border-color);border-radius:8px;padding:6px 9px;background:transparent;color:inherit;font-size:11px}







      .ac-chip.active{color:#7367f0;border-color:#7367f0;background:rgba(115,103,240,.08)}







      .ac-toast{position:fixed;bottom:20px;right:20px;z-index:1200;background:var(--bs-body-bg,#fff);border:1px solid var(--bs-border-color);border-radius:10px;box-shadow:0 8px 30px #0003;padding:12px;display:flex;align-items:center;max-width:400px}







      @media(max-width:1200px){.ac-modes{grid-template-columns:repeat(3,1fr)}.ac-filters{grid-template-columns:repeat(3,1fr)}}







      @media(max-width:767px){.ac-modes{grid-template-columns:repeat(2,1fr)}.ac-filters{grid-template-columns:repeat(2,1fr)}.ac-summary{grid-template-columns:repeat(2,1fr)}.ac-top{align-items:flex-start;flex-direction:column}.ac-search{grid-column:span 2}}







      @media(max-width:480px){.ac-filters{grid-template-columns:1fr}.ac-search{grid-column:span 1}.ac-callrow{align-items:flex-start;flex-direction:column;gap:8px}.ac-mini{grid-template-columns:repeat(2,1fr)}}







      @media print{.layout-menu,.layout-navbar,.ac-modes,.ac-filters,.ac-actions,.ac-footer,.ac-overlay,.ac-toast,.ac-table td:last-child,.ac-table th:last-child{display:none!important}.ac-table{min-width:0;font-size:9px}.ac-box{overflow:visible}.table-responsive{overflow:visible!important}}















      /* Aligned with StudentLowAttendanceReport: clean white cards, soft indigo accents. */







      .ac-root{--ac-border:var(--bs-border-color,#e3e7ed);--ac-bg:var(--bs-body-bg,#fff);--ac-text:var(--bs-body-color,#454b55)}







      .ac-page{min-width:0}.ac-master-v2{width:100%;min-width:0;margin-bottom:14px}







      .ac-top,.ac-box,.ac-mode,.ac-summary>div{border-radius:12px;box-shadow:0 4px 18px rgba(31,45,61,.035)}







      .ac-top{padding:15px 18px;margin-bottom:11px}.ac-top h4{font-size:20px;font-weight:850}







      .ac-top p{font-size:11px}.ac-kicker{color:#696cff}







      .ac-modes{grid-template-columns:repeat(3,minmax(0,1fr));gap:0;background:var(--ac-bg);border:1px solid var(--ac-border);border-radius:12px;overflow:hidden;margin-bottom:11px}







      .ac-mode{border:0;border-right:1px solid var(--ac-border);border-bottom:1px solid var(--ac-border);border-radius:0;box-shadow:none!important;min-height:72px;display:grid;grid-template-columns:27px 1fr;grid-template-rows:auto auto;align-content:center;column-gap:9px;row-gap:3px;padding:12px 15px}







      .ac-mode i{grid-row:1/3;font-size:22px;color:#696cff;align-self:center}







      .ac-mode strong{font-size:12px}.ac-mode small{font-size:10px;line-height:1.4}







      .ac-mode.active{background:rgba(105,108,255,.07);box-shadow:inset 0 -3px #696cff!important}







      .ac-box{margin-bottom:11px}.ac-section-head{padding:12px 14px}







      .ac-filters{grid-template-columns:repeat(5,minmax(0,1fr));gap:9px;padding:13px 14px}







      .ac-field>span{color:var(--bs-secondary-color,#737b86);font-size:10px;font-weight:750}







      .ac-field .form-control,.ac-field .form-select{border-radius:8px;min-height:39px;font-size:11px}







      .ac-summary{gap:9px;margin-bottom:11px}







      .ac-summary>div{padding:11px 13px}.ac-summary strong{font-size:19px}







      .ac-table{min-width:1000px;width:100%;table-layout:auto}







      .ac-table th{background:var(--bs-tertiary-bg,#f6f7f9);color:var(--bs-secondary-color,#616a76);font-size:10px;padding:11px 9px;font-weight:850}







      .ac-table td{font-size:11px;padding:11px 9px;border-bottom:1px solid var(--ac-border)}







      .ac-table td strong{font-size:11px}







      .ac-row-number{color:#87909b;font-weight:700}







      .ac-student-cell{display:flex;align-items:center;gap:9px;min-width:175px}







      .ac-student-cell>div,.ac-stack{display:flex;flex-direction:column;gap:3px;min-width:0}







      .ac-student-cell small,.ac-stack small{font-size:10px;color:var(--bs-secondary-color,#939ba6)}







      .ac-avatar{width:36px;height:36px;flex:0 0 36px;border-radius:50%;background:rgba(105,108,255,.10);color:#696cff;font-weight:850;font-size:11px;display:flex;align-items:center;justify-content:center}







      .ac-class-cell{min-width:130px}







      .ac-attendance-counts{display:flex;flex-wrap:wrap;gap:4px;margin-top:3px}







      .ac-attendance-counts span{padding:3px 6px;border-radius:5px;font-size:9px;font-weight:800}







      .ac-attendance-counts .present{background:#e8f8ef;color:#278b53}







      .ac-attendance-counts .absent{background:#ffeded;color:#d34849}







      .ac-progress{min-width:95px}.ac-progress>div:first-child{display:flex;justify-content:space-between;gap:5px;align-items:center}







      .ac-progress small{font-size:9px;color:#98a1ac}







      .ac-progress-track{height:6px;background:var(--bs-tertiary-bg,#e9ecf0);border-radius:8px;overflow:hidden;margin-top:7px}







      .ac-progress-track span{display:block;height:100%;border-radius:8px}







      .ac-progress .good{color:#278b53!important}.ac-progress .warning{color:#b9781c!important}







      .ac-progress .danger,.ac-progress .critical{color:#d34849!important}







      .ac-progress-track .good{background:#3ca66a}.ac-progress-track .warning{background:#dca13c}







      .ac-progress-track .danger,.ac-progress-track .critical{background:#d34849}







      .ac-response-cell{max-width:180px;min-width:120px}







      .ac-response-cell>strong{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width:175px}







      .ac-response-cell .ac-sort{font-size:10px;font-weight:700;color:var(--bs-secondary-color,#818995)}







      .ac-inline-actions{display:flex;gap:10px;margin-top:3px}.ac-inline-actions a{color:#278b53;font-size:15px}







      .ac-followup-btn{display:inline-flex;align-items:center;justify-content:center;gap:5px;background:rgba(105,108,255,.07);border:1px solid #696cff;color:#5f62e8;border-radius:7px;padding:8px 10px;font-size:10px;font-weight:800;white-space:nowrap}







      .ac-followup-btn:hover{background:#696cff;color:#fff}







      .ac-pill{border-radius:7px;padding:5px 7px;font-size:9px}







      .ac-mobile-list{display:none}







      @media(max-width:1199px){.ac-filters{grid-template-columns:repeat(3,minmax(0,1fr))}}







      @media(max-width:767px){







        .ac-page{padding-left:10px!important;padding-right:10px!important}







        .ac-modes{grid-template-columns:repeat(2,minmax(0,1fr))}







        .ac-mode{padding:10px;grid-template-columns:22px 1fr}







        .ac-mode i{font-size:20px}







        .ac-filters{grid-template-columns:repeat(2,minmax(0,1fr))}







        .ac-desktop-table{display:none}







        .ac-mobile-list{display:block}







        .ac-mobile-card{padding:13px;border-bottom:1px solid var(--ac-border)}







        .ac-mobile-head{display:flex;align-items:center;justify-content:space-between;gap:8px}







        .ac-mobile-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin:11px 0}







        .ac-mobile-grid>div{display:flex;flex-direction:column;gap:4px;padding:9px;border-radius:8px;background:var(--bs-tertiary-bg,#f6f7f9);min-width:0}







        .ac-mobile-grid small{font-size:9px;color:var(--bs-secondary-color,#9299a4)}







        .ac-mobile-grid strong{font-size:11px;overflow:hidden;text-overflow:ellipsis}







        .ac-mobile-grid span{font-size:10px;color:var(--bs-secondary-color,#9299a4);overflow:hidden;text-overflow:ellipsis}







        .ac-mobile-actions{display:flex;flex-wrap:wrap;gap:6px}







        .ac-mobile-actions .ac-followup-btn{flex:1}







        .ac-summary{grid-template-columns:repeat(2,minmax(0,1fr))}







      }







      @media(max-width:480px){.ac-filters{grid-template-columns:1fr}.ac-search{grid-column:span 1}.ac-modes{grid-template-columns:1fr 1fr}.ac-mode small{font-size:9px}}







    /* StudentLowAttendanceReport / MasterV2 visual language */



    .ac-root{--ac-border:#e3e7ed;--ac-bg:#fff;--ac-text:#454b55;background:#f6f7fb;min-height:100vh}



    .ac-page{max-width:1750px;margin:0 auto;min-width:0}



    .ac-top,.ac-box,.ac-summary>div{background:#fff;border:1px solid #e3e7ed;border-radius:12px;box-shadow:0 4px 18px rgba(31,45,61,.035)}



    .ac-top{padding:16px 18px;margin-bottom:11px}



    .ac-top h4{font-size:20px;font-weight:850;color:#25293c}



    .ac-top p{color:#9097a2;font-size:12px}



    .ac-kicker{color:#696cff}



    .ac-master-v2{margin-bottom:12px}



    .ac-modes{background:#fff;border:1px solid #e3e7ed;border-radius:12px;overflow:hidden;gap:0;grid-template-columns:repeat(3,minmax(0,1fr));margin-bottom:11px}



    .ac-mode{border:0;border-right:1px solid #e9ecf1;border-bottom:1px solid #e9ecf1;border-radius:0;box-shadow:none!important;background:#fff;min-height:74px;display:grid;grid-template-columns:26px minmax(0,1fr);grid-template-rows:auto auto;gap:3px 9px;align-content:center;padding:12px 15px}



    .ac-mode i{grid-row:1/3;color:#696cff;font-size:22px;align-self:center}



    .ac-mode strong{font-size:12px;color:#4d5561}.ac-mode small{font-size:10px;color:#949ba6}



    .ac-mode.active{background:#f7f7ff;border-color:#e3e7ed;box-shadow:inset 0 -3px #696cff!important}



    .ac-box{margin-bottom:11px}.ac-section-head{padding:12px 14px;border-bottom:1px solid #e8ebef}



    .ac-section-head strong{font-size:14px;color:#444b55}



    .ac-filters{grid-template-columns:repeat(5,minmax(0,1fr));gap:9px;padding:13px 14px}



    .ac-field>span{color:#737b86;font-size:10px;font-weight:750}



    .ac-field .form-control,.ac-field .form-select{border:1px solid #dce1e7;background:#fff;color:#4e5560;min-height:39px;border-radius:8px;font-size:11px}



    .ac-search-row{display:flex;gap:5px}.ac-search-row input{min-width:0;flex:1}



    .ac-summary{gap:9px;margin-bottom:11px}.ac-summary>div{padding:11px 13px}.ac-summary small{color:#9299a4;font-size:10px}.ac-summary strong{font-size:19px;color:#454b55}



    .ac-table{min-width:1000px;width:100%;table-layout:auto}



    .ac-table thead th{background:#f6f7f9;color:#616a76;font-size:10px;font-weight:850;padding:12px 9px;border-bottom:1px solid #dfe3e8}



    .ac-table tbody td{padding:12px 9px;font-size:11px;color:#4d545f;border-bottom:1px solid #eceff2}



    .ac-table tbody tr:hover{background:#fafbff}



    .ac-avatar{background:#eef0ff;color:#696cff}



    .ac-followup-btn{border:1px solid #696cff;background:#f7f7ff;color:#5f62e8;border-radius:7px;font-size:10px;font-weight:850}



    .ac-followup-btn:hover{background:#696cff;color:#fff}



    .ac-progress-track{height:7px;background:#e9ecf0}



    .ac-pill{border-radius:7px;font-size:9px;font-weight:850}



    .ac-footer{border-top:1px solid #e8ebef}



    .ac-modal{background:#fff;color:#454b55}



    @media(max-width:1199px){.ac-filters{grid-template-columns:repeat(3,minmax(0,1fr))}}



    @media(max-width:767px){.ac-page{padding-left:9px!important;padding-right:9px!important}.ac-modes{grid-template-columns:repeat(2,minmax(0,1fr))}.ac-filters{grid-template-columns:repeat(2,minmax(0,1fr))}.ac-top{flex-direction:column;align-items:flex-start}.ac-actions{width:100%}.ac-actions button{flex:1}.ac-desktop-table{display:none}.ac-mobile-list{display:block}.ac-summary{grid-template-columns:repeat(2,minmax(0,1fr))}}



    @media(max-width:480px){.ac-filters{grid-template-columns:1fr}.ac-search{grid-column:span 1}.ac-mode{padding:10px}.ac-mode small{font-size:9px}}







    @media print{.ac-root .no-print,.ac-master-v2,.ac-mobile-list{display:none!important}.ac-desktop-table{display:block!important}}







    `}</style>

      {/* Attendance-only layout fix: remove fixed-template navbar offset. */}
      <style>{`
        html.layout-navbar-fixed .attendance-dashboard.layout-wrapper,
        html.layout-navbar-fixed .attendance-dashboard.layout-wrapper > .layout-container,
        .attendance-dashboard.layout-wrapper > .layout-container {
          padding-top: 0 !important;
          margin-top: 0 !important;
        }
        html.layout-navbar-fixed .attendance-dashboard.layout-wrapper .layout-page,
        html.layout-navbar-fixed .layout-wrapper:not(.layout-without-menu).attendance-dashboard .layout-page,
        .attendance-dashboard.layout-wrapper .layout-page {
          padding-top: 0 !important;
          margin-top: 0 !important;
          min-width: 0;
        }
        .attendance-dashboard.layout-wrapper #layout-navbar.scai-topbar,
        html.layout-navbar-fixed .attendance-dashboard.layout-wrapper #layout-navbar {
          top: 0 !important;
          left: auto !important;
          right: auto !important;
          width: 100% !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          border-radius: 0 !important;
        }
        @media print {
          .attendance-dashboard.layout-wrapper #layout-navbar { display: none !important; }
        }
      `}</style>
    </>
  );
}
